import _sfc_main from "./component-library212.mjs";
import "./component-library213.mjs";
import normalizeComponent from "./component-library91.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: _setup.openable.onClickaway, expression: "openable.onClickaway" }], staticClass: "dropdown", class: _setup.containerClass }, [_vm._t("trigger", function() {
    return [_c(_setup.LinkButton, { ref: "buttonElement", staticClass: "dropdown__button", attrs: { "id": `dropdown${_setup.uid}`, "tag": "button", "type": "button", "outline": "", "small-padding": "", "is-wide": "", "aria-haspopup": "listbox", "aria-expanded": _setup.openable.isOpened.value, "title": _vm.caption, "disabled": _vm.disabled }, on: { "click": function($event) {
      $event.preventDefault();
      return _setup.openable.toggle.apply(null, arguments);
    } } }, [_c("span", { staticClass: "dropdown__button-caption" }, [_vm._t("captionBefore"), _vm._t("caption", function() {
      return [_vm._v(" " + _vm._s(_vm.caption) + " ")];
    })], 2), _c(_setup.Arrow, { staticClass: "dropdown__icon", attrs: { "direction": _setup.openable.isOpened.value ? "top" : "bottom", "tag": "span" } })], 1)];
  }, { "openable": _setup.openable, "disabled": _vm.disabled, "elementId": `dropdown${_setup.uid}`, "open": _setup.openable.open, "close": _setup.openable.close, "toggle": _setup.openable.toggle }), _c(_setup.DropdownContainer, { directives: [{ name: "show", rawName: "v-show", value: _setup.openable.isOpened.value, expression: "openable.isOpened.value" }], ref: "dropdownContainerElement", attrs: { "aria-labelledby": `dropdown${_setup.uid}`, "role": "listbox", "auto-width": _vm.autoWidth, "show-right": _setup.showRight }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._t("default")];
  }, proxy: true }, { key: "submit", fn: function() {
    return [_vm._t("submit")];
  }, proxy: true }, { key: "input", fn: function() {
    return [_vm._t("input")];
  }, proxy: true }], null, true) })], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "9c9f1e68",
  null,
  null
);
const Dropdown = __component__.exports;
export {
  Dropdown as default
};
